import { Input } from "reactstrap";

import useHelpers from "Hooks/useHelpers";
import styles from "components/ReactTable/Components/DefaultColumnFilter/DefaultColumnFilter.module.css";
import React, { useMemo, useState } from "react";

/** Like the default column filter, except it accepts a state setting function 
 * that can set a filter in the parent, for server side search.
 */
export default function ControlledColumnFilter({
    filterValue,
    setFilter,
    autoFocus = false,
    placeholder = "Search ...",
    onFocusChange,
}: {
    filterValue: string;
    setFilter: (value: string) => void;
    autoFocus?: boolean;
    placeholder?: string;
    onFocusChange?: (focused: boolean) => void;
}) {
    const [term, setTerm] = useState(filterValue);

    const { debounce } = useHelpers();
    const debouncedSetFilter = useMemo(() => debounce(setFilter, 400), [debounce, setFilter]);

    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        const value = e.target.value || "";
        setTerm(value);
        debouncedSetFilter(value);
    }

    return (
        <Input
            autoFocus={autoFocus}
            type="search"
            className={styles.searchInput}
            value={term}
            // Stop the click to select the search input from bubbling up and triggering a sort
            onClick={(e) => e.stopPropagation()}
            onChange={handleChange}
            onFocus={() => onFocusChange?.(true)}
            onBlur={() => onFocusChange?.(false)}
            placeholder={placeholder}
            // Highlight the text input background if column is being filtered
            style={{
                ...(term
                    ? {
                          backgroundColor: "var(--dimensionBlueHighlight)",
                      }
                    : {}),
            }}
        />
    );
}
